<router-outlet></router-outlet>
<app-toast *ngIf="notification$ | async as n" [visible]="true" [message]="n.message" [isError]="n.isError"></app-toast>
